import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useNavigate } from "react-router-dom";
import PartnerListComponent from "./component";

const PartnerListContainer = ({ getDataFromAPI }) => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [allPartners, setAllPartners] = useState([]);
  const [filteredPartners, setFilteredPartners] = useState([]);
  const [selectedPartnerId, setSelectedPartnerId] = useState(null);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize] = useState(20);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadMoreLoading, setLoadMoreLoading] = useState(false);

  const fetchPartners = useCallback(async (page = 0, isLoadMore = false) => {
    if (isLoadMore && (loadMoreLoading || !hasMore)) return;
    if (!isLoadMore && (loading || pageNumber !== page)) return;

    if (isLoadMore) {
      setLoadMoreLoading(true);
    } else {
      setLoading(true);
    }
    
    try {
      const response = await new Promise((resolve, reject) => {
        getDataFromAPI(
          `/dashboard/api/v2/admin/franchisee?pageNumber=${page}&pageSize=${pageSize}`,
          "GET",
          undefined,
          resolve,
          reject
        );
      });

      if (page === 0) {
        setAllPartners(response);
        setFilteredPartners(response);
      } else {
        setAllPartners(prev => [...prev, ...response]);
        setFilteredPartners(prev => [...prev, ...response]);
      }

      setHasMore(response.length === pageSize);
      setPageNumber(page);
    } catch (err) {
      console.error("Partner API Error:", err);
    } finally {
      if (isLoadMore) {
        setLoadMoreLoading(false);
      } else {
        setLoading(false);
      }
    }
  }, [pageNumber, hasMore, loading, loadMoreLoading, getDataFromAPI, pageSize]);

  // Initial load
  useEffect(() => {
    fetchPartners(0, false);
  }, []);

  // Search functionality with debounce
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchValue.trim() === "") {
        setFilteredPartners(allPartners);
      } else {
        const searchLower = searchValue.toLowerCase();
        const filtered = allPartners.filter(
          partner =>
            partner.ownerId?.toString().includes(searchLower) ||
            partner.cohortId?.toString().includes(searchLower)
        );
        setFilteredPartners(filtered);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [searchValue, allPartners]);

  const handleBlock = () => {
    navigate(`/home/configuration/partner/block-payout`);
  };

  const handleUnblock = () => {
    navigate(`/home/configuration/partner/block-payout-list`);
  };

  const handleLoadMore = () => {
    if (hasMore && !loadMoreLoading) {
      fetchPartners(pageNumber + 1, true);
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <PartnerListComponent
      partners={filteredPartners}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      onBlock={handleBlock}
      onUnblock={handleUnblock}
      onSelectPartner={setSelectedPartnerId}
      selectedPartnerId={selectedPartnerId}
      onLoadMore={handleLoadMore}
      hasMore={hasMore}
      loading={loadMoreLoading}
      onGoBack={handleGoBack}
    />
  );
};

export default connect(null, { getDataFromAPI })(PartnerListContainer);